import { API, authClient } from "../index";

export const getNotifications = (accessToken, take = 100) => {
  return authClient(accessToken).get(`${API}/notifications?take=${take}`);
};

export const getNotificationHistory = (accessToken, page = 1, limit = 25) => {
  return authClient(accessToken).get(
    `${API}/notifications/history?pagina=${page}&limite=${limit}`
  );
};
